import Ringsense from "./Ringsense/index.js";
import Insights from "./Insights/index.js";
import Status from "./Status/index.js";
import Audio from "./Audio/index.js";
import Text from "./Text/index.js";
class Index {
    rc;
    constructor(rc) {
        this.rc = rc;
    }
    path() {
        return "/ai";
    }
    text() {
        return new Text(this);
    }
    audio() {
        return new Audio(this);
    }
    status() {
        return new Status(this);
    }
    insights() {
        return new Insights(this);
    }
    ringsense() {
        return new Ringsense(this);
    }
}
export default Index;
